import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import React from "react";
import {useLocation} from "react-router";

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function ErrorPage() {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Erreur | Lose Awards</title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Une erreur s'est produite
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            {location.state.message}
          </Typography>

          <Button to="/" size="large" variant="contained" component={RouterLink} sx={{marginTop: 5}}>
            Accueil
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
